import { motion } from 'motion/react';
import { Link } from 'react-router';

export default function TermsAndPrivacy() {
  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="mb-8 flex justify-start">
            <Link to="/" aria-label="MedHub">
              <img
                src="/images/HospitalLogo.png"
                alt="MedHub"
                width={1280}
                height={1280}
                className="h-24 w-auto object-contain"
              />
            </Link>
          </div>

          <section dir="rtl" className="mb-16">
            <h1 className="mb-2 text-2xl font-bold text-gray-900">
              سياسة الاستخدام والخصوصية
            </h1>
            <p className="mb-8 text-gray-500">
              منصة MedHub للنقل الإسعافي غير الطارئ
            </p>

            <div className="space-y-8">
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  أولاً: التعريفات
                </h2>
                <ul className="list-disc space-y-3 pr-6 text-gray-600">
                  <li>
                    <strong>المنصة (MedHub):</strong> منصة إلكترونية مملوكة
                    ومشغّلة حصرياً من قبل شركة التخصصي العامة المحدودة، وتعمل
                    كوسيط تقني لتمكين العملاء من طلب خدمات النقل الإسعافي غير
                    الطارئ من مزودي الخدمة المسجلين.
                  </li>
                  <li>
                    <strong>الشركة المالكة:</strong> شركة التخصصي العامة
                    المحدودة، وهي الجهة الوحيدة المسؤولة عن تشغيل المنصة تقنياً.
                  </li>
                  <li>
                    <strong>العميل:</strong> أي جهة أو شخص يسجل لطلب الخدمات عبر
                    المنصة.
                  </li>
                  <li>
                    <strong>مزود الخدمة:</strong> جهة مرخّصة نظامياً تعرض
                    خدماتها عبر المنصة.
                  </li>
                  <li>
                    <strong>الخدمة:</strong> خدمات النقل الإسعافي غير الطارئ
                    المقدمة من مزود الخدمة.
                  </li>
                  <li>
                    <strong>العمولة:</strong> المقابل المالي المستحق للشركة
                    المالكة عن الطلبات التي تتم عبر المنصة وفق الاتفاقيات
                    المبرمة.
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  ثانياً: طبيعة العلاقة القانونية
                </h2>
                <ol className="list-decimal space-y-2 pr-6 text-gray-600">
                  <li>المنصة لا تقدم خدمات إسعافية.</li>
                  <li>
                    لا تنشأ أي علاقة شراكة أو وكالة أو تضامن بين المنصة ومزودي
                    الخدمة.
                  </li>
                  <li>
                    العلاقة التعاقدية للخدمة تنشأ حصرياً بين العميل ومزود
                    الخدمة.
                  </li>
                  <li>دور المنصة يقتصر على تمكين الاستخدام التقني للنظام.</li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  ثالثاً: إخلاء المسؤولية الكامل
                </h2>
                <ol className="list-decimal space-y-3 pr-6 text-gray-600">
                  <li>
                    لا تتحمل المنصة أي مسؤولية عن:
                    <ul className="mt-2 list-disc space-y-1 pr-6">
                      <li>جودة الخدمة.</li>
                      <li>التأخير أو الإلغاء.</li>
                      <li>الأخطاء التشغيلية.</li>
                      <li>المخالفات النظامية لمزود الخدمة.</li>
                      <li>أي أضرار مباشرة أو غير مباشرة.</li>
                    </ul>
                  </li>
                  <li>
                    يتحمل مزود الخدمة كامل المسؤولية القانونية والتشغيلية
                    والطبية والمالية عن الخدمات.
                  </li>
                  <li>
                    لا تتحمل المنصة أي مسؤولية عن إخلال العميل بالتزاماته.
                  </li>
                  <li>
                    لا يجوز لأي طرف الرجوع على المنصة بأي مطالبة تعويضية ناشئة
                    عن تنفيذ الخدمة.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  رابعاً: المدفوعات والتحصيل
                </h2>
                <ol className="list-decimal space-y-2 pr-6 text-gray-600">
                  <li>
                    جميع المدفوعات الخاصة بالخدمة تتم مباشرة بين العميل ومزود
                    الخدمة.
                  </li>
                  <li>لا تدير المنصة عمليات التحصيل أو التسوية بين الطرفين.</li>
                  <li>
                    تستحق الشركة المالكة عمولتها بمجرد إتمام التعاقد عبر المنصة.
                  </li>
                  <li>العمولة غير قابلة للاسترداد تحت أي ظرف.</li>
                  <li>
                    تعتبر سجلات المنصة المرجع الحصري في احتساب الطلبات
                    والعمولات.
                  </li>
                  <li>
                    يقر الطرفان بأن بيانات المنصة نهائية وملزمة ما لم يثبت خطأ
                    تقني جسيم.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  خامساً: حظر التحايل وعدم الالتفاف
                </h2>
                <ol className="list-decimal space-y-3 pr-6 text-gray-600">
                  <li>
                    يُحظر على العميل ومزود الخدمة إبرام أي تعاقد مباشر خارج
                    المنصة بخصوص طلب تم عبرها.
                  </li>
                  <li>
                    في حال المخالفة:
                    <ul className="mt-2 list-disc space-y-1 pr-6">
                      <li>تستحق الشركة كامل العمولة.</li>
                      <li>يحق للمنصة تعليق أو إلغاء الحساب.</li>
                      <li>يحق للمنصة المطالبة بالتعويض عن أي ضرر.</li>
                    </ul>
                  </li>
                  <li>
                    يسري هذا الحظر طوال مدة العلاقة وأي تعامل لاحق مرتبط بالطلب.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  سادساً: مسؤولية البيانات
                </h2>
                <ol className="list-decimal space-y-2 pr-6 text-gray-600">
                  <li>
                    يتحمل كل طرف مسؤولية صحة واكتمال البيانات التي يقدمها.
                  </li>
                  <li>
                    لا تتحمل المنصة مسؤولية أي نتائج ناتجة عن بيانات غير صحيحة.
                  </li>
                  <li>
                    يلتزم الطرفان بعدم إدخال بيانات مضللة أو مخالفة للأنظمة.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  سابعاً: الخصوصية ومعالجة البيانات
                </h2>

                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    1. نطاق البيانات
                  </h3>
                  <p className="mb-2 leading-relaxed text-gray-600">
                    يجوز للمنصة جمع ومعالجة:
                  </p>
                  <ul className="list-disc space-y-1 pr-6 text-gray-600">
                    <li>بيانات التسجيل.</li>
                    <li>بيانات الطلبات.</li>
                    <li>بيانات الأداء.</li>
                    <li>البيانات التشغيلية.</li>
                    <li>سجلات الاستخدام.</li>
                    <li>البيانات الإحصائية.</li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    2. أغراض الاستخدام
                  </h3>
                  <ul className="list-disc space-y-1 pr-6 text-gray-600">
                    <li>تشغيل النظام.</li>
                    <li>احتساب العمولات.</li>
                    <li>إصدار التقارير.</li>
                    <li>الامتثال للأنظمة.</li>
                    <li>التحليل وتحسين الأداء.</li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    3. الإفصاح النظامي
                  </h3>
                  <p className="leading-relaxed text-gray-600">
                    يجوز للمنصة الإفصاح عن البيانات للجهات الحكومية أو القضائية
                    متى طُلب ذلك نظاماً، دون أي مسؤولية عليها.
                  </p>
                </div>

                <div>
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    4. البيانات المجمعة
                  </h3>
                  <p className="leading-relaxed text-gray-600">
                    استخدام البيانات المجمعة أو الإحصائية أو التقارير لا يُعد
                    انتهاكاً للسرية.
                  </p>
                </div>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  ثامناً: الملكية الفكرية
                </h2>
                <ol className="list-decimal space-y-2 pr-6 text-gray-600">
                  <li>
                    جميع الأنظمة والبرمجيات والتقارير والتحليلات ولوحات التحكم
                    مملوكة حصرياً لشركة التخصصي العامة المحدودة.
                  </li>
                  <li>يحتفظ كل طرف بملكية بياناته الأصلية فقط.</li>
                  <li>
                    لا يحق لأي طرف نسخ أو إعادة استخدام أو استغلال النظام أو
                    تقاريره دون إذن كتابي.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  تاسعاً: تحديد المسؤولية المالية
                </h2>
                <ol className="list-decimal space-y-2 pr-6 text-gray-600">
                  <li>
                    في جميع الأحوال، لا تتجاوز مسؤولية المنصة (إن وجدت) قيمة
                    العمولة المستلمة عن الطلب محل النزاع.
                  </li>
                  <li>
                    لا تتحمل المنصة أي أضرار غير مباشرة أو تبعية أو خسارة أرباح.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  عاشراً: عزل مسؤولية الجهات المالكة
                </h2>
                <p className="mb-2 leading-relaxed text-gray-600">
                  لا يترتب على:
                </p>
                <ul className="mb-2 list-disc space-y-1 pr-6 text-gray-600">
                  <li>الشركة القابضة.</li>
                  <li>أو مستشفى الملك فيصل التخصصي ومركز الأبحاث.</li>
                </ul>
                <p className="leading-relaxed text-gray-600">
                  أي التزام قانوني أو مالي أو تعاقدي مباشر أو غير مباشر ناتج عن
                  تشغيل أو استخدام المنصة.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  الحادي عشر: القوة القاهرة
                </h2>
                <p className="leading-relaxed text-gray-600">
                  لا تتحمل المنصة أي مسؤولية عن أي إخلال ناتج عن أحداث خارجة عن
                  السيطرة المعقولة.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  الثاني عشر: النظام الواجب التطبيق
                </h2>
                <p className="leading-relaxed text-gray-600">
                  تخضع هذه السياسة لأنظمة المملكة العربية السعودية، ويكون
                  الاختصاص القضائي لمحاكم مدينة الرياض.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  إقرار وموافقة
                </h2>
                <p className="leading-relaxed font-semibold text-gray-700">
                  بالضغط على خانة الموافقة عند إنشاء الحساب في المنصة، يقر
                  المستخدم بأنه قرأ هذه السياسة وفهم جميع بنودها ووافق عليها،
                  وتعد هذه الموافقة الإلكترونية نافذة وملزمة دون الحاجة إلى أي
                  توقيع خطي.
                </p>
              </div>
            </div>
          </section>

          <hr className="my-12 border-gray-200" />

          <section dir="ltr" className="mb-16">
            <h1 className="mb-2 text-2xl font-bold text-gray-900">
              Usage and Privacy Policy
            </h1>
            <p className="mb-4 text-gray-500">
              MedHub Platform for Non-Emergency Medical Transport
            </p>
            <p className="mb-8 leading-relaxed text-gray-500 italic">
              The following is an English translation of the Arabic policy
              above. In the event of any discrepancy between the Arabic text and
              this English translation, the Arabic text shall prevail.
            </p>

            <div className="space-y-8">
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  First: Definitions
                </h2>
                <ul className="list-disc space-y-3 pl-6 text-gray-600">
                  <li>
                    <strong>Platform (MedHub):</strong> An electronic platform
                    exclusively owned and operated by Altakassusi General Ltd
                    Company, acting as a technical intermediary to enable
                    Clients to request non-emergency medical transport services
                    from registered Service Providers.
                  </li>
                  <li>
                    <strong>Owning Company:</strong> Altakassusi General Ltd
                    Company, the sole entity responsible for the technical
                    operation of the Platform.
                  </li>
                  <li>
                    <strong>Client:</strong> Any entity or person who registers
                    to request services through the Platform.
                  </li>
                  <li>
                    <strong>Service Provider:</strong> A legally licensed entity
                    that offers its services through the Platform.
                  </li>
                  <li>
                    <strong>Service:</strong> The non-emergency medical
                    transport services provided by the Service Provider.
                  </li>
                  <li>
                    <strong>Commission:</strong> The financial consideration due
                    to the Owning Company for the orders completed through the
                    Platform in accordance with the concluded agreements.
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Second: Nature of the Legal Relationship
                </h2>
                <ol className="list-decimal space-y-2 pl-6 text-gray-600">
                  <li>The Platform does not provide ambulance services.</li>
                  <li>
                    No partnership, agency, or joint liability relationship
                    arises between the Platform and the Service Providers.
                  </li>
                  <li>
                    The contractual relationship for the Service arises
                    exclusively between the Client and the Service Provider.
                  </li>
                  <li>
                    The Platform's role is limited to enabling the technical use
                    of the system.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Third: Full Disclaimer of Liability
                </h2>
                <ol className="list-decimal space-y-3 pl-6 text-gray-600">
                  <li>
                    The Platform bears no liability whatsoever for:
                    <ul className="mt-2 list-disc space-y-1 pl-6">
                      <li>The quality of the Service.</li>
                      <li>Delay or cancellation.</li>
                      <li>Operational errors.</li>
                      <li>The Service Provider's regulatory violations.</li>
                      <li>Any direct or indirect damages.</li>
                    </ul>
                  </li>
                  <li>
                    The Service Provider bears full legal, operational, medical,
                    and financial responsibility for the services.
                  </li>
                  <li>
                    The Platform bears no liability for the Client's breach of
                    its obligations.
                  </li>
                  <li>
                    No party may have recourse against the Platform with any
                    claim for compensation arising from the performance of the
                    Service.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Fourth: Payments and Collection
                </h2>
                <ol className="list-decimal space-y-2 pl-6 text-gray-600">
                  <li>
                    All payments relating to the Service are made directly
                    between the Client and the Service Provider.
                  </li>
                  <li>
                    The Platform does not manage the collection or settlement
                    processes between the two parties.
                  </li>
                  <li>
                    The Owning Company's commission becomes due upon the
                    conclusion of the contract through the Platform.
                  </li>
                  <li>
                    The commission is non-refundable under any circumstances.
                  </li>
                  <li>
                    The Platform's records constitute the exclusive reference
                    for the calculation of orders and commissions.
                  </li>
                  <li>
                    Both parties acknowledge that the Platform's data is final
                    and binding unless a material technical error is proven.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Fifth: Prohibition of Circumvention
                </h2>
                <ol className="list-decimal space-y-3 pl-6 text-gray-600">
                  <li>
                    The Client and the Service Provider are prohibited from
                    concluding any direct contract outside the Platform with
                    respect to an order made through it.
                  </li>
                  <li>
                    In the event of a violation:
                    <ul className="mt-2 list-disc space-y-1 pl-6">
                      <li>The Company is entitled to the full commission.</li>
                      <li>
                        The Platform has the right to suspend or cancel the
                        account.
                      </li>
                      <li>
                        The Platform has the right to claim compensation for any
                        damage.
                      </li>
                    </ul>
                  </li>
                  <li>
                    This prohibition remains in effect throughout the duration
                    of the relationship and any subsequent dealing related to
                    the order.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Sixth: Data Responsibility
                </h2>
                <ol className="list-decimal space-y-2 pl-6 text-gray-600">
                  <li>
                    Each party is responsible for the accuracy and completeness
                    of the data it provides.
                  </li>
                  <li>
                    The Platform bears no responsibility for any consequences
                    resulting from inaccurate data.
                  </li>
                  <li>
                    Both parties undertake not to enter misleading data or data
                    that violates applicable laws.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Seventh: Privacy and Data Processing
                </h2>

                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    1. Scope of Data
                  </h3>
                  <p className="mb-2 leading-relaxed text-gray-600">
                    The Platform may collect and process:
                  </p>
                  <ul className="list-disc space-y-1 pl-6 text-gray-600">
                    <li>Registration data.</li>
                    <li>Order data.</li>
                    <li>Performance data.</li>
                    <li>Operational data.</li>
                    <li>Usage logs.</li>
                    <li>Statistical data.</li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    2. Purposes of Use
                  </h3>
                  <ul className="list-disc space-y-1 pl-6 text-gray-600">
                    <li>Operating the system.</li>
                    <li>Calculating commissions.</li>
                    <li>Issuing reports.</li>
                    <li>Compliance with applicable laws and regulations.</li>
                    <li>Analysis and performance improvement.</li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    3. Statutory Disclosure
                  </h3>
                  <p className="leading-relaxed text-gray-600">
                    The Platform may disclose data to governmental or judicial
                    authorities whenever legally required to do so, without any
                    liability on its part.
                  </p>
                </div>

                <div>
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    4. Aggregated Data
                  </h3>
                  <p className="leading-relaxed text-gray-600">
                    The use of aggregated or statistical data or reports shall
                    not be deemed a breach of confidentiality.
                  </p>
                </div>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Eighth: Intellectual Property
                </h2>
                <ol className="list-decimal space-y-2 pl-6 text-gray-600">
                  <li>
                    All systems, software, reports, analytics, and dashboards
                    are exclusively owned by Altakassusi General Ltd Company.
                  </li>
                  <li>
                    Each party retains ownership of its original data only.
                  </li>
                  <li>
                    No party may copy, reuse, or exploit the system or its
                    reports without written permission.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Ninth: Limitation of Financial Liability
                </h2>
                <ol className="list-decimal space-y-2 pl-6 text-gray-600">
                  <li>
                    In all cases, the Platform's liability, if any, shall not
                    exceed the value of the commission received for the order in
                    dispute.
                  </li>
                  <li>
                    The Platform shall not be liable for any indirect or
                    consequential damages or loss of profits.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Tenth: Isolation of the Owning Entities' Liability
                </h2>
                <p className="mb-2 leading-relaxed text-gray-600">
                  No direct or indirect legal, financial, or contractual
                  obligation arising from the operation or use of the Platform
                  shall attach to:
                </p>
                <ul className="list-disc space-y-1 pl-6 text-gray-600">
                  <li>The holding company.</li>
                  <li>
                    Or King Faisal Specialist Hospital and Research Centre.
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Eleventh: Force Majeure
                </h2>
                <p className="leading-relaxed text-gray-600">
                  The Platform bears no liability for any breach resulting from
                  events beyond its reasonable control.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Twelfth: Governing Law
                </h2>
                <p className="leading-relaxed text-gray-600">
                  This Policy is governed by the laws of the Kingdom of Saudi
                  Arabia, and the courts of the city of Riyadh shall have
                  jurisdiction.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Acknowledgment and Consent
                </h2>
                <p className="leading-relaxed font-semibold text-gray-700">
                  By ticking the acceptance checkbox upon creating the account
                  on the Platform, the user acknowledges that they have read
                  this Policy, understood all of its provisions, and agreed
                  thereto. This electronic acceptance shall be valid and binding
                  without the need for any handwritten signature.
                </p>
              </div>
            </div>
          </section>
        </motion.div>
      </div>
    </div>
  );
}
